import {
  Button,
  CircularProgress,
  DialogActions,
  DialogContent,
  DialogContentText,
  Dialog as DialogMaterial,
  DialogTitle,
} from '@mui/material';

const Dialog = (props) => {
  return (
    <DialogMaterial
      autofocus
      fullWidth={props.fullWidth}
      open={!!props.visible}
      sx={props.sx}>
      <DialogTitle
        id='alert-dialog-title'
        sx={{ fontWeight: 'bold', fontSize: 18 }}>
        {props.title}
      </DialogTitle>
      <DialogContent>
        {props.renderAsHtml && <div dangerouslySetInnerHTML={{ __html: props.contenttext }} />}
        {props.contenttext && !props.renderAsHtml && <DialogContentText>{props.contenttext}</DialogContentText>}
        {props.children}
      </DialogContent>
      {props?.buttons && (
        <DialogActions sx={{ flexWrap: 'noWrap' }}>
          {props.buttons.map((buttons, index) => {
            return (
              <Button
                {...buttons.otherParams}
                sx={{ ...buttons.style }}
                disabled={buttons.disabled || buttons.loading}
                onClick={() => {
                  if (buttons.setLoading) buttons.setLoading(true);
                  buttons.onClick();
                }}
                key={index}
                startIcon={
                  buttons.loading ?
                    <CircularProgress
                      size={16}
                      color='inherit'
                    />
                  : buttons.icon
                }>
                {buttons.title}
              </Button>
            );
          })}
        </DialogActions>
      )}
    </DialogMaterial>
  );
};

export default Dialog;
